import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "image" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "input" }
const _hoisted_4 = { class: "input-wrapper" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "Naam", -1)
const _hoisted_6 = {
  key: 0,
  class: "input-wrapper"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "Team", -1)
const _hoisted_8 = {
  key: 1,
  class: "input-wrapper"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, "Team", -1)
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "replacement" }
const _hoisted_12 = ["checked", "id"]
const _hoisted_13 = ["for"]
const _hoisted_14 = { class: "buttons" }
const _hoisted_15 = ["disabled"]

import {onMounted, ref} from "vue";
	import FetchOptions from "../interfaces/FetchOptions";
	import {FetchData} from "../utils/FetchData";
	import {DateFormatter} from "../utils/DateFormatter";
	import ImageComponent from '../components/ImageComponent.vue';
	import emitter from '../main';

	
export default /*#__PURE__*/_defineComponent({
  __name: 'DriverCard',
  props: {
    driver: {},
    index: {}
  },
  emits: [
		'updateDriver',
		'deleteDriver',
		'editTeam',
		'replaceDriver'
	],
  setup(__props: any, { emit: __emit }) {

	const driver = ref({});
	const team = ref({});
	const file = ref(null);

	const teams = ref([]);
	const newTeam = ref(1);

	const props = __props;

	const emit = __emit;

	onMounted(() => {
		driver.value = JSON.parse(JSON.stringify(props.driver));
		team.value = JSON.parse(JSON.stringify(props.driver.team));

		if(driver.value.id == undefined)
			RetrieveTeams();
	});

	async function RetrieveTeams() {
		const data = await FetchData('teams');
		if(!data.isError)
			teams.value = data.data;
	}

	async function saveDriver() {
		const body = driver.value;
		delete body.races;
		delete body.team;
		delete body.team_id;

		if(body.id !== undefined) {
			const options: FetchOptions = {
				method: 'PATCH',
				headers: {
					"Content-Type": 'application/json'
				},
				body: JSON.stringify(body)
			};

			const data = await FetchData('drivers/' + driver.value.id, options);
			if(!data.isError) {
				emitter.emit('showMessage', {message: 'Coureur opgeslagen', header: 'Gelukt'});
				uploadImage();
			}
		}
		else {
			body.team_id = newTeam.value;

			const options: FetchOptions = {
				method: 'POST',
				headers: {
					"Content-Type": 'application/json'
				},
				body: JSON.stringify(body)
			};

			const data = await FetchData('drivers', options);
			if(!data.isError) {
				driver.value = data.data;
				team.value = data.data.team;
				emit('updateDriver', driver.value, props.index);
				emitter.emit('showMessage', {message: 'Coureur toegevoegd', header: 'Gelukt'});
				uploadImage();
			}
		}
	}

	async function uploadImage() {
		if(file.value == null)
			return;

		const body = new FormData();
		body.append('image', file.value);
		body.append('id', driver.value.id);

		const options: FetchOptions = {
			method: 'POST',
			body: body
		};

		const data = await FetchData('images', options);
		if(data.isError)
			return;

		driver.value.image = undefined;
		setTimeout(() => {
			driver.value.image = data.img;
		}, 1);
	}

	function onFileChange(event: object) {
		if(!event.target.files.length) {
			file.value = null;
			return;
		}

		file.value = event.target.files[0];
	}

	function replaceDriver() {
		emit('replaceDriver', driver.value);
	}

	function deleteDriver() {
		emit('deleteDriver', driver.value);
	}

	function editTeam() {
		emit('editTeam', driver.value);
	}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["driver-card card", {replacement: driver.value.is_replacement}])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(ImageComponent, {
        src: driver.value.image
      }, null, 8, ["src"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((driver.value.name) = $event))
          }, null, 512), [
            [_vModelText, driver.value.name]
          ])
        ]),
        (driver.value.id != undefined)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("span", null, [
                _createTextVNode("Bij "),
                _createElementVNode("b", null, _toDisplayString(team.value.name), 1),
                _createTextVNode(" vanaf "),
                _createElementVNode("b", null, _toDisplayString(_unref(DateFormatter)(driver.value.with_team_since).date), 1)
              ]),
              _createElementVNode("button", {
                class: "content-box",
                onClick: editTeam
              }, " Team verwisselen ")
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _hoisted_9,
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((newTeam).value = $event))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(teams.value, (team) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: team,
                    value: team.id
                  }, _toDisplayString(team.name), 9, _hoisted_10))
                }), 128))
              ], 512), [
                [_vModelSelect, newTeam.value]
              ])
            ])),
        _createElementVNode("div", _hoisted_11, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((driver.value.is_replacement) = $event)),
            checked: driver.value.is_replacement,
            id: driver.value.id
          }, null, 8, _hoisted_12), [
            [_vModelCheckbox, driver.value.is_replacement]
          ]),
          _createElementVNode("label", {
            for: driver.value.id
          }, "Is vervanger", 8, _hoisted_13)
        ]),
        _createElementVNode("input", {
          type: "file",
          onChange: onFileChange,
          accept: "Image/*"
        }, null, 32)
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("button", {
          class: "content-box",
          onClick: deleteDriver
        }, " Verwijderen "),
        _createElementVNode("button", {
          class: "content-box",
          disabled: driver.value.is_replacement,
          onClick: replaceDriver
        }, " Vervangen ", 8, _hoisted_15),
        _createElementVNode("button", {
          class: "content-box",
          onClick: saveDriver
        }, " Opslaan ")
      ])
    ])
  ], 2))
}
}

})